import { Breadcrumb } from 'antd';
import React from "react";

export default (() => {
  return (
    <Breadcrumb style={{textAlign: 'left',paddingBottom:20}}>
      <Breadcrumb.Item>操作日志列表</Breadcrumb.Item>
    </Breadcrumb>
  )
})